<template>
    <Modal size="md text-sm" @close="close">
        <div class="text-center">
            <h3 class="m-b-lg">
                Ret din betaling
            </h3>

            <div class="alert alert-info text-left">
                <div class="text-center">
                    <h5 class="strong">
                        💰Du er i gang med at ændre din betaling for jobbet💰
                    </h5>
                </div>
                <p>
                    Indsæt den pris du har aftalt med virksomheden i betalingsfeltet og klik på
                    knappen "Ret betaling".
                </p>
                <p>
                    <b class="underline">Vigtigt</b>: Du bør kun anvende "Ret betaling" når du er
                    helt enig med virksomheden om betalingen.
                </p>
            </div>

            <form @submit.prevent="update">
                <div class="m-xl">
                    <JobInfluencerPricingTable
                        :form="form"
                        :brand-name="job.jobable.brand.name"
                        :campaign-name="job.jobable.name"
                        :always-edit="true"
                    >
                    </JobInfluencerPricingTable>
                </div>
                <button type="submit" class="btn btn-xl btn-success btn-load" :disabled="form.busy">
                    Ret betaling
                </button>
            </form>
        </div>
    </Modal>
</template>
<script type="text/babel">
import JobInfluencerPricingTable from 'dashboard-js/components/jobs/JobInfluencerPricingTable'
import Modal from 'dashboard-js/components/Modal'

export default {
    components: { Modal, JobInfluencerPricingTable },

    props: ['job'],

    data() {
        return {
            form: new SparkForm(this.job),
        }
    },

    methods: {
        update() {
            Spark.post(route('api.job.action', [this.job.id, 'edit-price']), this.form).then(
                response => {
                    Bus.$emit('jobUpdated', response.data)

                    this.close()
                }
            )
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>
